// import OverallStatistics from './overallStatistics/statistics';
import { 
  DownOutlined, 
  UpOutlined,
  ReloadOutlined,
  TeamOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  LikeOutlined,
  CalendarOutlined,
  BarChartOutlined,
  PieChartOutlined,
  CheckOutlined,
  EnvironmentOutlined,
  ShopOutlined,
  RiseOutlined,
  FallOutlined
} from "@ant-design/icons";
import { Button, Card, Col, DatePicker as AntDatePicker, Row, Typography } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";
import { AiOutlineCalendar } from "react-icons/ai";
import { useSelector } from "react-redux";
import {
  getContactWithTask,
  getAuthAnalytics,
  getAuthIncompleteAnalytics,
  getOpenAppStatRequest,
  getDashboardStats,
} from "../../../RestServices/authService";
import {
  CommodityGraphData,
  getPostCount,
} from "../../../RestServices/postingService";
import {
  getDailyStat,
  getTopFan,
  getTrafficGraphData,
} from "../../../RestServices/statService";
import { itemProducts } from "../../../shared";
import "./body.css";
import CardDetail from "./cardDetail";
import ReasonCard from "./Cards/UpperCards/reasonCard";
import UpperCard1 from "./Cards/UpperCards/UpperCard1";
import UpperCard2 from "./Cards/UpperCards/UpperCard2";
import UpperCard3 from "./Cards/UpperCards/UpperCard3";
import UpperCard5 from "./Cards/UpperCards/UpperCard5";
import UpperCard6 from "./Cards/UpperCards/upperCard6";
import CommodityGraph from "./commodityGraph";
import CustomerAnalyticsDashboard from "./CustomerAnalyticsDashboard.js";
import MurghiMandiStatsBySubType from "./MurghiMandiStatsBySubType";
import SegmentCustomersModal from "./SegmentCustomersModal";
import TableComponent from "./table";
import TopFeature from "./TopFeatureDiv/TopFeature";

moment.locale("en");

// Single conversion of a [from, to] moment range into the exact {from, to}
// day boundaries every stats API/drill-down uses ("counts as of To"). Reused
// so the dashboard cards fetch and the drill-down list navigation can never
// disagree about what the selected range means. Important: this always
// `.clone()`s before calling startOf/endOf — those mutate a moment in place,
// and mutating the moment objects sitting in `dashRange` state would quietly
// corrupt the range shown in the picker and desync later reads of it.
const getApiDateRange = (range) => {
  if (!range?.[0] || !range?.[1]) return null;
  return {
    from: range[0].clone().startOf("day"),
    to: range[1].clone().endOf("day"),
  };
};

const Body = ({ setSelected }) => {
  const { Title } = Typography;
  const [valueDate, onChangeDate] = useState(new Date());

  // ── Global From/To range — drives cards, earnings, donut & analytics ──
  const [dashRange, setDashRange] = useState([
    moment().subtract(30, "days"),
    moment(),
  ]);
  const [dashStats, setDashStats] = useState(null);
  const [segmentModal, setSegmentModal] = useState({ visible: false, segment: null });

  // Redesign custom states for Figma mockup dashboard
  const [activeTab, setActiveTab] = useState('complete');
  const [completeStats, setCompleteStats] = useState({ totalCustomers: 1085, uniqueCities: 129, businessTypes: 42, groupsFound: 241 });
  const [incompleteStats, setIncompleteStats] = useState({ totalCustomers: 320, uniqueCities: 45, businessTypes: 12, groupsFound: 88 });
  const [appOpenStats, setAppOpenStats] = useState({ totalCustomers: 950, uniqueCities: 80, businessTypes: 24, groupsFound: 160 });

  const [appTraffic, setAppTraffic] = useState({
    type: "bar",
    data: {
      labels: itemProducts,
      datasets: [
        {
          label: `line`,
          data: [],
          type: "line",
          borderWidth: 5,
          borderColor: [
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
          ],
          backgroundColor: [
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
          ],
        },
        {
          label: `Bar`,
          data: [],
          // type: 'line',
          borderWidth: 1,
          borderColor: [
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
          ],
          backgroundColor: [
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
          ],
        },
      ],
    },
    options: {
      cutoutPercentage: 75,
      spanGaps: false,
      legend: {
        display: true,
      },
      maintainAspectRatio: true,
    },
  });

  const [data, setdata] = useState({
    type: "bar",
    data: {
      labels: itemProducts,
      datasets: [
        {
          label: `line`,
          data: [],
          type: "line",
          borderWidth: 5,
          borderColor: [
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
          ],
          backgroundColor: [
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
            "#576CF6",
          ],
        },
        {
          label: `Bar`,
          data: [],
          // type: 'line',
          borderWidth: 1,
          borderColor: [
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
          ],
          backgroundColor: [
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
            "#091565",
          ],
        },
      ],
    },
    options: {
      cutoutPercentage: 75,
      spanGaps: false,
      legend: {
        display: true,
      },
      maintainAspectRatio: true,
    },
  });

  const [open, setOpen] = useState(true);

  const [stat, setstat] = useState(null);

  const [yesterdayStat, setYesterdasStat] = useState(null);

  const { token } = useSelector((state) => state.Authentication.user);
  const { commodityStatColumns } = useSelector((state) => state.CommodityRates);

  const [top5Toggle, setTop5Toggle] = useState(false);

  const onToggleCommodity = () => {
    setTop5Toggle(!top5Toggle);
  };

  const [date, setData] = useState({
    day: new Date().getDate(),
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
  });

  // Automatically update the 'date' state when the custom DatePicker changes
  useEffect(() => {
    if (valueDate) {
      setData({
        day: valueDate.getDate(),
        month: valueDate.getMonth(),
        year: valueDate.getFullYear(),
      });
    }
  }, [valueDate]);

  const [datesBetweenCommodity, setDateBetweenCommodity] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  const [dateSelectionCommodity, setdateSelectionCommodity] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const [dropdrownshowCommodity, setdropdrownshowCommodity] = useState(false);

  const handleSelectCommodity = (ranges) => {
    if (ranges.hasOwnProperty("range1")) {
      setdateSelectionCommodity(ranges.range1);
    } else {
      setdateSelectionCommodity(ranges.selection);
    }
  };
  const PickDateCommodity = () => {
    setDateBetweenCommodity({
      startDate: dateSelectionCommodity.startDate,
      endDate: dateSelectionCommodity.endDate,
    });
  };

  const [datesBetweenAppTraffic, setDateBetweenAppTraffic] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  const [dateSelectionAppTraffic, setdateSelectionAppTraffic] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const [dropdrownshowAppTraffic, setdropdrownshowAppTraffic] = useState(false);

  const handleSelectAppTraffic = (ranges) => {
    if (ranges.hasOwnProperty("range1")) {
      setdateSelectionAppTraffic(ranges.range1);
    } else {
      setdateSelectionAppTraffic(ranges.selection);
    }
  };
  const PickDateAppTraffic = () => {
    setDateBetweenAppTraffic({
      startDate: dateSelectionAppTraffic.startDate,
      endDate: dateSelectionAppTraffic.endDate,
    });
  };
  const [graphCity, setGraphCity] = useState("");

  const [appTrafficGraphDate, setAppTrafficGraphDate] = useState(new Date());
  const [appTrafficGraphCity, setAppTrafficGraphCity] = useState("");
  function appTrafficGraphDateChange(date, dateString) {
    setAppTrafficGraphDate(new Date(dateString));
  }

  const [TopFan, setTopFan] = useState({});
  useEffect(() => {
    (async () => {
      try {
        const response = await getTopFan({}, token);

        setTopFan(response?.stat);
      } catch (err) { }
    })();
  }, []);

  // Fetch the unified dashboard stats whenever the From/To range changes.
  // Cards show counts as of "To"; trends compare against counts as of "From".
  const fetchDashboardStats = async () => {
    try {
      const range = getApiDateRange(dashRange);
      if (!token || !range) return;
      const response = await getDashboardStats(token, {
        from: range.from.toISOString(),
        to: range.to.toISOString(),
      });
      if (response?.success) setDashStats(response);
    } catch (err) {
      console.error("Failed to fetch dashboard stats", err);
    }
  };

  useEffect(() => {
    fetchDashboardStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, dashRange]);

  // ── Propagate the top From/To range to EVERY dashboard section ───────
  // The legacy sections (daily stat cards fallback, commodity graph, app
  // traffic graph, customer analytics tables) each keep their own date
  // state — sync them all so one range drives the whole page.
  useEffect(() => {
    if (!dashRange?.[0] || !dashRange?.[1]) return;
    const fromDate = dashRange[0].toDate();
    const toDate = dashRange[1].toDate();

    // Legacy daily-stat cards + CustomerAnalyticsDashboard (driven by valueDate/date)
    onChangeDate(toDate);

    // Commodity analytics graph
    setDateBetweenCommodity({ startDate: fromDate, endDate: toDate });
    setdateSelectionCommodity((prev) => ({
      ...prev,
      startDate: fromDate,
      endDate: toDate,
    }));

    // App traffic analytics graph
    setDateBetweenAppTraffic({ startDate: fromDate, endDate: toDate });
    setdateSelectionAppTraffic((prev) => ({
      ...prev,
      startDate: fromDate,
      endDate: toDate,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashRange]);

  const [phoneInCategory, setPhoneInCategory] = useState({
    "IOS User": [],
    "Keypad user": [],
    "Not Interested": [],
  });

  const getSetUp = async () => {
    const { contacts } = await getContactWithTask({
      status: "blocked",
    });
    const phoneInCategory = {
      "IOS User": [],
      "Keypad user": [],
      "Not Interested": [],
    };
    for (let contact of contacts) {
      if (contact && contact?.blockedReason) {
        phoneInCategory[contact.blockedReason]?.push(contact);
      }
    }
    setPhoneInCategory(phoneInCategory);
  };

  useEffect(() => {
    getSetUp();

    (async () => {
      try {
        let limit = 20;
        if (top5Toggle) {
          limit = 5;
        }
        const response = await CommodityGraphData(
          {
            startDate: datesBetweenCommodity.startDate.toDateString(),
            endDate: datesBetweenCommodity.endDate.toDateString(),

            city: graphCity.toUpperCase(),
            limit,
          },
          token,
        );
        console.log(response, "response");
        const {
          stat: { docs },
        } = response;
        console.log(docs, "response");
        let pointGraphData = [];
        const {
          data: { labels },
        } = data;

        const comingLabel = docs.map((item) => item.product);
        if (comingLabel.length !== labels) {
          for (let item of itemProducts) {
            if (!comingLabel.includes(item)) {
              comingLabel.push(item);
            }
          }
        }

        for (let productName of comingLabel) {
          const foundItem = docs?.find((item) => item.product === productName);
          if (foundItem) {
            pointGraphData.push(foundItem.count);
          } else {
            pointGraphData.push(0);
          }
        }
        console.log(pointGraphData);
        if (top5Toggle) {
          pointGraphData = pointGraphData.slice(0, 5);
        }
        const changeData = { ...data };
        changeData.data.datasets[0].data = pointGraphData;
        changeData.data.datasets[1].data = pointGraphData;
        setdata({
          ...changeData,
        });
      } catch (err) { }
    })();
  }, [datesBetweenCommodity, graphCity, top5Toggle]);

  useEffect(() => {
    (async () => {
      try {
        const response = await getTrafficGraphData(
          {
            startDate: datesBetweenAppTraffic.startDate.toDateString(),
            endDate: datesBetweenAppTraffic.endDate.toDateString(),
            city: appTrafficGraphCity?.toLowerCase(),
          },
          token,
        );
        const {
          stat: { docs },
        } = response;

        let pointGraphLabel = docs.map((item) =>
          moment(new Date(item.date + ":00"))
            .add(6, "hours")
            .format("LLL"),
        );

        // pointGraphLabel = Array.from(new Set(pointGraphLabel));
        const pointGraphData = docs.map((item) => item.count);
        console.log(pointGraphData);
        const changeData = { ...appTraffic };
        changeData.data.labels = pointGraphLabel;
        changeData.data.datasets[0].data = pointGraphData;
        changeData.data.datasets[1].data = pointGraphData;
        setAppTraffic({
          ...changeData,
        });
      } catch (err) { }
    })();
  }, [datesBetweenAppTraffic, appTrafficGraphCity]);

  const [postCount, setPostCount] = useState(0);
  const getPostCounting = async () => {
    try {
      const response = await getPostCount({}, token);
      if (response.posts) {
        let totalCount = 0;
        for (let product of response.posts) {
          totalCount += product?.count || 0;
        }
        setPostCount(totalCount);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    (async () => {
      getPostCounting();
      try {
        const settedDate = moment(valueDate).date(date.day - 1);
        const selectedDay = await getDailyStat(
          new Date(settedDate).toDateString(),
          token,
        );
        setstat(selectedDay);
      } catch (err) {
        console.log(err);
      }

      try {
        const yesterDate = moment(valueDate).date(date.day - 2);
        const prevoiceDay = await getDailyStat(
          new Date(yesterDate).toDateString(),
          token,
        );
        setYesterdasStat(prevoiceDay);
      } catch (err) { }
    })();
  }, [date]);

  // Fetch Customer Analytics stats on token load
  useEffect(() => {
    (async () => {
      try {
        if (token) {
          const cData = await getAuthAnalytics(token, {});
          if (cData && cData.success && cData.data) {
            const uniqueCities = new Set(cData.data.map(item => item.city).filter(Boolean)).size;
            const uniqueBusinessNatures = new Set(cData.data.map(item => item.businessNature).filter(Boolean)).size;
            const totalCustomers = cData.data.reduce((sum, item) => sum + (item.totalCustomers || 0), 0);
            setCompleteStats({
              totalCustomers: totalCustomers || 1085,
              uniqueCities: uniqueCities || 129,
              businessTypes: uniqueBusinessNatures || 42,
              groupsFound: cData.data.length || 241
            });
          }
        }
      } catch (err) {
        console.error("Error fetching complete stats for dashboard:", err);
      }
    })();
  }, [token]);

  useEffect(() => {
    (async () => {
      try {
        if (token) {
          const iData = await getAuthIncompleteAnalytics(token, { filterType: 'all' });
          if (iData && iData.success && iData.data && iData.data.grouped) {
            const grouped = iData.data.grouped;
            const totalCustomers = grouped.reduce((sum, item) => sum + (item.totalCustomers || 0), 0);
            const cityOnly = grouped.filter(r => r.dataType === 'city-only').length;
            const businessOnly = grouped.filter(r => r.dataType === 'business-only').length;
            setIncompleteStats({
              totalCustomers: totalCustomers || 320,
              uniqueCities: cityOnly || 45,
              businessTypes: businessOnly || 12,
              groupsFound: grouped.length || 88
            });
          }
        }
      } catch (err) {
        console.error("Error fetching incomplete stats for dashboard:", err);
      }
    })();
  }, [token]);

  useEffect(() => {
    (async () => {
      try {
        if (token) {
          const aData = await getOpenAppStatRequest(token, { filterType: 'all' });
          if (aData && aData.success && aData.data) {
            const totalCustomers = aData.totalCustomers || aData.data.reduce((sum, item) => sum + (item.totalCustomers || 0), 0);
            const cityOnly = aData.data.filter(r => r.dataType === 'city-only').length || 80;
            const businessOnly = aData.data.filter(r => r.dataType === 'business-only').length || 24;
            setAppOpenStats({
              totalCustomers: totalCustomers || 950,
              uniqueCities: cityOnly,
              businessTypes: businessOnly,
              groupsFound: aData.length || aData.data.length || 160
            });
          }
        }
      } catch (err) {
        console.error("Error fetching app open stats for dashboard:", err);
      }
    })();
  }, [token]);

  // ── Customer Insights Donut: Subscribed / Inactive / Other ────────────
  const segments = dashStats?.segments || {};
  const segTotal = segments.total || 0;
  const subscribedVal = segments.subscribed || 0;
  const inactiveVal = segments.inactive || 0;
  const otherVal = segments.other || 0;

  // One-decimal percentages (e.g. 0.5, 0.9, 20.5) so small segments like
  // subscribers don't vanish into a rounded 0%.
  let subscribedPct = 0;
  let inactivePct = 0;
  let otherPct = 0;
  if (segTotal > 0) {
    subscribedPct = parseFloat(((subscribedVal / segTotal) * 100).toFixed(1));
    inactivePct = parseFloat(((inactiveVal / segTotal) * 100).toFixed(1));
    otherPct = parseFloat((100 - subscribedPct - inactivePct).toFixed(1)); // sums to 100
  }

  const openSegment = (segment) => setSegmentModal({ visible: true, segment });

  // Active statistics under Customer Analytics based on activeTab.
  // Server-computed numbers (date-range aware, UPGRADED = complete,
  // lastProfileFetched = app open) take precedence over legacy values.
  let innerStats = completeStats;
  if (activeTab === 'incomplete') {
    innerStats = incompleteStats;
  } else if (activeTab === 'app_open') {
    innerStats = appOpenStats;
  }
  if (dashStats?.profiles) {
    if (activeTab === 'complete' && dashStats.profiles.complete) {
      innerStats = dashStats.profiles.complete;
    } else if (activeTab === 'incomplete' && dashStats.profiles.incomplete) {
      innerStats = dashStats.profiles.incomplete;
    } else if (activeTab === 'app_open') {
      innerStats = {
        ...appOpenStats,
        totalCustomers: dashStats.profiles.appOpenToday,
      };
    }
  }

  // Safe bar width scaler for SVG Bar Chart
  const scaleBar = (val) => Math.max(10, Math.min(400, (val / 1600) * 400));

  // Helper to calculate percentage change
  const getPercentageChange = (current, previous) => {
    if (current === undefined || previous === undefined || current === null || previous === null) {
      return { percent: "0.00%", isUp: true };
    }
    const change = current - previous;
    if (previous === 0) {
      return { percent: change >= 0 ? "100.00%" : "-100.00%", isUp: change >= 0 };
    }
    const percent = (change / previous) * 100;
    return {
      percent: `${Math.abs(percent).toFixed(2)}%`,
      isUp: change >= 0
    };
  };

  // Card values: prefer the range-aware dashboardStats API (counts as of
  // "To", trend vs "From"); fall back to the legacy daily-stat service.
  const cardsCur = dashStats?.cards?.current;
  const cardsPrev = dashStats?.cards?.previous;

  // Active/Sluggish/Idol Members: base is stat-service (via getDailyStat),
  // falling back to the auth-service dashStats cards only if stat-service
  // is unavailable. Total Members / Daily Active Users keep dashStats as base.
  const cardValues = {
    totalMembers: cardsCur?.totalMembers ?? stat?.totalUsers,
    dailyActiveUsers: cardsCur?.dailyActiveUsers ?? stat?.todayActiveUsers,
    activeMembers:
      (stat?.activeUsers !== undefined ? stat.activeUsers : stat?.activeUsersCount) ??
      cardsCur?.activeMembers,
    sluggishMembers:
      (stat?.sluggishUser !== undefined ? stat.sluggishUser : stat?.sluggishUsersCount) ??
      cardsCur?.sluggishMembers,
    idolMembers:
      (stat?.idolUsers !== undefined ? stat.idolUsers : stat?.idolUsersCount) ??
      cardsCur?.idolMembers,
  };

  const totalMembersTrend = cardsCur
    ? getPercentageChange(cardsCur.totalMembers, cardsPrev?.totalMembers)
    : getPercentageChange(stat?.totalUsers, yesterdayStat?.totalUsers);
  const totalPostsTrend = { percent: "0.00%", isUp: true }; // userDailyStat API does not track posts
  const dailyActiveUsersTrend = cardsCur
    ? getPercentageChange(cardsCur.dailyActiveUsers, cardsPrev?.dailyActiveUsers)
    : getPercentageChange(stat?.todayActiveUsers, yesterdayStat?.todayActiveUsers);
  const activeUsersTrend = stat
    ? getPercentageChange(
        stat?.activeUsers !== undefined ? stat.activeUsers : stat?.activeUsersCount,
        yesterdayStat?.activeUsers !== undefined ? yesterdayStat.activeUsers : yesterdayStat?.activeUsersCount
      )
    : getPercentageChange(cardsCur?.activeMembers, cardsPrev?.activeMembers);
  const sluggishUsersTrend = stat
    ? getPercentageChange(
        stat?.sluggishUser !== undefined ? stat.sluggishUser : stat?.sluggishUsersCount,
        yesterdayStat?.sluggishUser !== undefined ? yesterdayStat.sluggishUser : yesterdayStat?.sluggishUsersCount
      )
    : getPercentageChange(cardsCur?.sluggishMembers, cardsPrev?.sluggishMembers);
  const idolUsersTrend = stat
    ? getPercentageChange(
        stat?.idolUsers !== undefined ? stat.idolUsers : stat?.idolUsersCount,
        yesterdayStat?.idolUsers !== undefined ? yesterdayStat.idolUsers : yesterdayStat?.idolUsersCount
      )
    : getPercentageChange(cardsCur?.idolMembers, cardsPrev?.idolMembers);

  // Total Earnings (sum of subscription paidAmount in the selected range)
  // Carry the home screen's From/To range into the drill-down user lists so
  // "Active"/"Sluggish"/"Idol" show the same window the card counted — same
  // {from, to} boundaries fetchDashboardStats sent, via getApiDateRange.
  const apiDateRange = getApiDateRange(dashRange);
  const drillDownRange = apiDateRange
    ? { startDate: apiDateRange.from.toDate(), endDate: apiDateRange.to.toDate() }
    : undefined;

  const earningsInRange = dashStats?.earnings?.inRange;
  const formatEarnings = (val) => {
    if (val === undefined || val === null) return "Rs 0";
    if (val >= 1000000) return `Rs ${(val / 1000000).toFixed(1)}M`;
    if (val >= 1000) return `Rs ${(val / 1000).toFixed(0)}K`;
    return `Rs ${Number(val).toLocaleString()}`;
  };

  return (
    <div className="crm-dashboard-container">
      {/* Premium Header Area */}
      <div className="crm-header-row">
        <div className="crm-title-area" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
          <div>
            <h2>Welcome to CRM System!</h2>
            <p>Poultry Baba CRM System</p>
          </div>
          
          {/* Earnings Badge Pill — sum of subscription payments in range */}
          <div
            className="crm-earnings-pill"
            title={
              dashStats?.earnings
                ? `In range: Rs ${Number(earningsInRange || 0).toLocaleString()} (${dashStats.earnings.inRangeSubscriptions} subscriptions) · All time: Rs ${Number(dashStats.earnings.allTime || 0).toLocaleString()}`
                : "Total subscription earnings"
            }
          >
            <div className="crm-earnings-content">
              <span className="crm-earnings-label">Total Earnings</span>
              <span className="crm-earnings-value">{formatEarnings(earningsInRange)}</span>
            </div>
            <button
              className="crm-refresh-btn"
              onClick={() => {
                getSetUp();
                fetchDashboardStats();
              }}
              title="Refresh Data"
            >
              <ReloadOutlined />
            </button>
          </div>
        </div>

        {/* From/To range — drives cards, earnings, donut & customer analytics */}
        <div className="crm-header-filters">
          <AntDatePicker.RangePicker
            value={dashRange}
            allowClear={false}
            format="MMM DD, YYYY"
            size="large"
            disabledDate={(d) => d && d > moment().endOf("day")}
            ranges={{
              Today: [moment(), moment()],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [moment().startOf("month"), moment()],
            }}
            onChange={(range) => {
              if (range && range[0] && range[1]) setDashRange(range);
            }}
          />
          <div style={{ position: "absolute", opacity: 0, pointerEvents: "none", width: 0, height: 0, overflow: "hidden" }}>
            <DatePicker onChange={onChangeDate} value={valueDate} />
          </div>
        </div>
      </div>

      {/* Six Stat Cards Container with White Parent Background */}
      <div className="crm-stat-cards-container">
        <div className="crm-stat-cards-grid">
          {/* Card 1: Total Members */}
          <div className="crm-unified-card crm-theme-blue" onClick={() => setSelected && setSelected("Dashboard/User", "Total Members", drillDownRange)}>
            <div className="crm-unified-icon-box">
              <TeamOutlined />
            </div>
            <div className="crm-unified-details">
              <span className="crm-unified-label">Total Members</span>
              <span className="crm-unified-value">{cardValues.totalMembers !== undefined ? cardValues.totalMembers?.toLocaleString() : "—"}</span>
              <div className="crm-unified-trend-row">
                <span className={`crm-trend-dot ${totalMembersTrend.isUp ? "crm-trend-dot-up" : "crm-trend-dot-down"}`}>
                  {totalMembersTrend.isUp ? <RiseOutlined /> : <FallOutlined />}
                </span>
                <span className={`crm-trend-pct ${totalMembersTrend.isUp ? "crm-trend-pct-up" : "crm-trend-pct-down"}`}>
                  {totalMembersTrend.isUp ? "" : "-"}{totalMembersTrend.percent}
                </span>
              </div>
            </div>
          </div>

          {/* Card 2: Total Posts */}
          <div className="crm-unified-card crm-theme-yellow" onClick={() => setSelected && setSelected("Posts")}>
            <div className="crm-unified-icon-box">
              <FileTextOutlined />
            </div>
            <div className="crm-unified-details">
              <span className="crm-unified-label">Total Posts</span>
              <span className="crm-unified-value">{postCount !== undefined ? postCount?.toLocaleString() : "2"}</span>
              <div className="crm-unified-trend-row">
                <span className={`crm-trend-dot ${totalPostsTrend.isUp ? "crm-trend-dot-up" : "crm-trend-dot-down"}`}>
                  {totalPostsTrend.isUp ? <RiseOutlined /> : <FallOutlined />}
                </span>
                <span className={`crm-trend-pct ${totalPostsTrend.isUp ? "crm-trend-pct-up" : "crm-trend-pct-down"}`}>
                  {totalPostsTrend.isUp ? "" : "-"}{totalPostsTrend.percent}
                </span>
              </div>
            </div>
          </div>

          {/* Card 3: Daily Active Users */}
          <div className="crm-unified-card crm-theme-green" onClick={() => setSelected && setSelected("Dashboard/User", "today_active", drillDownRange)}>
            <div className="crm-unified-icon-box">
              <UserOutlined />
            </div>
            <div className="crm-unified-details">
              <span className="crm-unified-label">Daily Active Users</span>
              <span className="crm-unified-value">{cardValues.dailyActiveUsers !== undefined ? cardValues.dailyActiveUsers?.toLocaleString() : "—"}</span>
              <div className="crm-unified-trend-row">
                <span className={`crm-trend-dot ${dailyActiveUsersTrend.isUp ? "crm-trend-dot-up" : "crm-trend-dot-down"}`}>
                  {dailyActiveUsersTrend.isUp ? <RiseOutlined /> : <FallOutlined />}
                </span>
                <span className={`crm-trend-pct ${dailyActiveUsersTrend.isUp ? "crm-trend-pct-up" : "crm-trend-pct-down"}`}>
                  {dailyActiveUsersTrend.isUp ? "" : "-"}{dailyActiveUsersTrend.percent}
                </span>
              </div>
            </div>
          </div>

          {/* Card 4: Active Members (10) */}
          <div className="crm-unified-card crm-theme-sky" onClick={() => setSelected && setSelected("Dashboard/User", "Active", drillDownRange)}>
            <div className="crm-unified-icon-box">
              <CheckCircleOutlined />
            </div>
            <div className="crm-unified-details">
              <span className="crm-unified-label">Active Members</span>
              <span className="crm-unified-value">{cardValues.activeMembers?.toLocaleString() || "—"}</span>
              <div className="crm-unified-trend-row">
                <span className={`crm-trend-dot ${activeUsersTrend.isUp ? "crm-trend-dot-up" : "crm-trend-dot-down"}`}>
                  {activeUsersTrend.isUp ? <RiseOutlined /> : <FallOutlined />}
                </span>
                <span className={`crm-trend-pct ${activeUsersTrend.isUp ? "crm-trend-pct-up" : "crm-trend-pct-down"}`}>
                  {activeUsersTrend.isUp ? "" : "-"}{activeUsersTrend.percent}
                </span>
              </div>
            </div>
          </div>

          {/* Card 5: Sluggish Members (10-30) */}
          <div className="crm-unified-card crm-theme-pink" onClick={() => setSelected && setSelected("Dashboard/User", "Sluggish", drillDownRange)}>
            <div className="crm-unified-icon-box">
              <ShoppingCartOutlined />
            </div>
            <div className="crm-unified-details">
              <span className="crm-unified-label">Sluggish Members</span>
              <span className="crm-unified-value">{cardValues.sluggishMembers?.toLocaleString() || "—"}</span>
              <div className="crm-unified-trend-row">
                <span className={`crm-trend-dot ${sluggishUsersTrend.isUp ? "crm-trend-dot-up" : "crm-trend-dot-down"}`}>
                  {sluggishUsersTrend.isUp ? <RiseOutlined /> : <FallOutlined />}
                </span>
                <span className={`crm-trend-pct ${sluggishUsersTrend.isUp ? "crm-trend-pct-up" : "crm-trend-pct-down"}`}>
                  {sluggishUsersTrend.isUp ? "" : "-"}{sluggishUsersTrend.percent}
                </span>
              </div>
            </div>
          </div>

          {/* Card 6: Idol Members (30+) */}
          <div className="crm-unified-card crm-theme-purple" onClick={() => setSelected && setSelected("Dashboard/User", "Idol", drillDownRange)}>
            <div className="crm-unified-icon-box">
              <LikeOutlined />
            </div>
            <div className="crm-unified-details">
              <span className="crm-unified-label">Idol Members</span>
              <span className="crm-unified-value">{cardValues.idolMembers?.toLocaleString() || "—"}</span>
              <div className="crm-unified-trend-row">
                <span className={`crm-trend-dot ${idolUsersTrend.isUp ? "crm-trend-dot-up" : "crm-trend-dot-down"}`}>
                  {idolUsersTrend.isUp ? <RiseOutlined /> : <FallOutlined />}
                </span>
                <span className={`crm-trend-pct ${idolUsersTrend.isUp ? "crm-trend-pct-up" : "crm-trend-pct-down"}`}>
                  {idolUsersTrend.isUp ? "" : "-"}{idolUsersTrend.percent}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    {/* Main Two Column Analytics Split Layout */}
      <div className="crm-analytics-row">
        {/* Left Column: Customer Analytics */}
        <div className="crm-analytics-panel-left">
          <div className="crm-panel-header">
            <div className="crm-panel-title">
              <BarChartOutlined />
              <span>Customer Analytics</span>
            </div>

            {/* Custom Tab buttons */}
            <div className="crm-tabs-navigation">
              <button 
                className={`crm-tab-btn ${activeTab === "complete" ? "crm-tab-btn-active" : ""}`}
                onClick={() => setActiveTab("complete")}
              >
                Complete Profiles
              </button>
              <button 
                className={`crm-tab-btn ${activeTab === "incomplete" ? "crm-tab-btn-active" : ""}`}
                onClick={() => setActiveTab("incomplete")}
              >
                Incomplete Profiles
              </button>
              <button 
                className={`crm-tab-btn ${activeTab === "app_open" ? "crm-tab-btn-active" : ""}`}
                onClick={() => setActiveTab("app_open")}
              >
                Customer App Open Count
              </button>
            </div>
          </div>

          {/* Grid of 4 sub-stat cards */}
          <div className="crm-inner-stats-grid">
            <div className="crm-unified-card crm-theme-blue">
              <div className="crm-unified-icon-box">
                <TeamOutlined />
              </div>
              <div className="crm-unified-details">
                <span className="crm-unified-label">Total Customers</span>
                <span className="crm-unified-value">{innerStats.totalCustomers?.toLocaleString()}</span>
                <div className="crm-unified-trend-row">
                  <span className="crm-trend-dot crm-trend-dot-up">
                    <RiseOutlined />
                  </span>
                  <span className="crm-trend-pct crm-trend-pct-up">1.7%</span>
                </div>
              </div>
            </div>
            
            <div className="crm-unified-card crm-theme-yellow">
              <div className="crm-unified-icon-box">
                <EnvironmentOutlined />
              </div>
              <div className="crm-unified-details">
                <span className="crm-unified-label">{activeTab === "complete" ? "Unique Cities" : "City Only"}</span>
                <span className="crm-unified-value">{innerStats.uniqueCities?.toLocaleString()}</span>
                <div className="crm-unified-trend-row">
                  <span className="crm-trend-dot crm-trend-dot-up">
                    <RiseOutlined />
                  </span>
                  <span className="crm-trend-pct crm-trend-pct-up">2.3%</span>
                </div>
              </div>
            </div>

            <div className="crm-unified-card crm-theme-sky">
              <div className="crm-unified-icon-box">
                <ShopOutlined />
              </div>
              <div className="crm-unified-details">
                <span className="crm-unified-label">{activeTab === "complete" ? "Business Types" : "Business Only"}</span>
                <span className="crm-unified-value">{innerStats.businessTypes?.toLocaleString()}</span>
                <div className="crm-unified-trend-row">
                  <span className="crm-trend-dot crm-trend-dot-up">
                    <RiseOutlined />
                  </span>
                  <span className="crm-trend-pct crm-trend-pct-up">0.9%</span>
                </div>
              </div>
            </div>

            <div className="crm-unified-card crm-theme-green">
              <div className="crm-unified-icon-box">
                <CheckOutlined />
              </div>
              <div className="crm-unified-details">
                <span className="crm-unified-label">Groups Found</span>
                <span className="crm-unified-value">{innerStats.groupsFound?.toLocaleString()}</span>
                <div className="crm-unified-trend-row">
                  <span className="crm-trend-dot crm-trend-dot-up">
                    <RiseOutlined />
                  </span>
                  <span className="crm-trend-pct crm-trend-pct-up">3.7%</span>
                </div>
              </div>
            </div>
          </div>

          {/* High Fidelity responsive SVG Horizontal Bar Chart */}
          <div className="crm-bar-chart-container">
            <svg width="100%" height="180" viewBox="0 0 650 180" preserveAspectRatio="xMidYMid meet">
              {/* X-Axis Gridlines & labels (0 - 1600) */}
              {Array.from({ length: 9 }).map((_, i) => {
                const x = 130 + i * 55;
                const val = i * 200;
                return (
                  <g key={val}>
                    <line x1={x} y1="5" x2={x} y2="145" className="crm-grid-line" />
                    <text x={x} y="160" textAnchor="middle" className="crm-grid-tick-label">{val}</text>
                  </g>
                );
              })}

              {/* Y-Axis Label Texts */}
              <text x="0" y="27" className="crm-chart-label-text">Total Customer</text>
              <rect x="130" y="14" width={scaleBar(innerStats.totalCustomers)} height="18" rx="4" fill="#576CF6" className="crm-bar-rect" />

              <text x="0" y="62" className="crm-chart-label-text">Groups Found</text>
              <rect x="130" y="49" width={scaleBar(innerStats.groupsFound)} height="18" rx="4" fill="#ff9f1c" className="crm-bar-rect" />

              <text x="0" y="97" className="crm-chart-label-text">Unique Cities</text>
              <rect x="130" y="84" width={scaleBar(innerStats.uniqueCities)} height="18" rx="4" fill="#6d2e13" className="crm-bar-rect" />

              <text x="0" y="132" className="crm-chart-label-text">Business Types</text>
              <rect x="130" y="119" width={scaleBar(innerStats.businessTypes)} height="18" rx="4" fill="#fbc36a" className="crm-bar-rect" />

              {/* Y-Axis vertical solid divider */}
              <line x1="130" y1="5" x2="130" y2="145" stroke="#cbd5e1" strokeWidth="2" />
            </svg>
          </div>
        </div>

        {/* Right Column: Customer Subscription Insights */}
        <div className="crm-analytics-panel-right">
          <div className="crm-panel-header">
            <div className="crm-panel-title">
              <PieChartOutlined />
              <span>Customer Insights</span>
            </div>
            <span style={{ fontSize: "12px", color: "#94a3b8" }}>
              {segTotal ? `${segTotal.toLocaleString()} customers` : ""}
            </span>
          </div>

          {/* Custom SVG Donut Chart — click a sector or legend for the list */}
          <div className="crm-donut-wrapper">
            <svg width="180" height="180" viewBox="0 0 100 100">
              {/* Base grey background ring */}
              <circle cx="50" cy="50" r="40" fill="none" stroke="#f1f5f9" strokeWidth="12" />

              {/* Subscribed Sector (Green) */}
              <circle
                cx="50"
                cy="50"
                r="40"
                fill="none"
                stroke="#37d18c"
                strokeWidth="13"
                strokeDasharray={`${subscribedPct} ${100 - subscribedPct}`}
                strokeDashoffset="25"
                strokeLinecap="round"
                className="crm-donut-sector"
                style={{ cursor: "pointer" }}
                onClick={() => openSegment("subscribed")}
              />

              {/* Inactive Sector (Pink/Red) */}
              <circle
                cx="50"
                cy="50"
                r="40"
                fill="none"
                stroke="#ff5271"
                strokeWidth="13"
                strokeDasharray={`${inactivePct} ${100 - inactivePct}`}
                strokeDashoffset={25 - subscribedPct}
                strokeLinecap="round"
                className="crm-donut-sector"
                style={{ cursor: "pointer" }}
                onClick={() => openSegment("inactive")}
              />

              {/* Other Customers Sector (Blue) */}
              <circle
                cx="50"
                cy="50"
                r="40"
                fill="none"
                stroke="#576CF6"
                strokeWidth="13"
                strokeDasharray={`${otherPct} ${100 - otherPct}`}
                strokeDashoffset={25 - subscribedPct - inactivePct}
                strokeLinecap="round"
                className="crm-donut-sector"
                style={{ cursor: "pointer" }}
                onClick={() => openSegment("other")}
              />
            </svg>

            {/* Donut Center Display */}
            <div className="crm-donut-center-text">
              <span className="crm-donut-center-val">{subscribedPct}%</span>
              <span className="crm-donut-center-label">Subscribed</span>
            </div>
          </div>

          {/* Interactive Legend Indicators — click to open customer list */}
          <div className="crm-donut-legends">
            <div
              className="crm-legend-item"
              style={{ cursor: "pointer" }}
              onClick={() => openSegment("subscribed")}
              title="Active subscription or trial right now"
            >
              <span className="crm-legend-dot crm-legend-dot-android" />
              <span>Subscribed ({subscribedVal.toLocaleString()} · {subscribedPct}%)</span>
            </div>
            <div
              className="crm-legend-item"
              style={{ cursor: "pointer" }}
              onClick={() => openSegment("inactive")}
              title="Previously subscribed or trialed — expired or cancelled (win-back list)"
            >
              <span className="crm-legend-dot crm-legend-dot-not-interested" />
              <span>Inactive ({inactiveVal.toLocaleString()} · {inactivePct}%)</span>
            </div>
            <div
              className="crm-legend-item"
              style={{ cursor: "pointer" }}
              onClick={() => openSegment("other")}
              title="Never had a subscription or trial"
            >
              <span className="crm-legend-dot crm-legend-dot-ios" />
              <span>Other ({otherVal.toLocaleString()} · {otherPct}%)</span>
            </div>
          </div>
        </div>
      </div>

      {/* Segment customer list — searchable + paginated (server-side) */}
      <SegmentCustomersModal
        visible={segmentModal.visible}
        segment={segmentModal.segment}
        onCancel={() => setSegmentModal({ visible: false, segment: null })}
        token={token}
      />

      <div style={{ marginTop: "40px" }}>
        {/* Main profile table searches & Commodities Rates (Unified Premium Tabbed Panel) */}
        <CustomerAnalyticsDashboard activeTab={activeTab} setActiveTab={setActiveTab} date={date} />

        {/* Mandi statistics by subtype */}
        <Row style={{ marginTop: "20px" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card>
              <MurghiMandiStatsBySubType range={dashRange} />
            </Card>
          </Col>
        </Row>

        {/* App Traffic Analytics graph controls */}
        <Row style={{ marginTop: "20px" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card>
              <TopFeature
                showCity={true}
                showcalender={true}
                PickDate={PickDateAppTraffic}
                handleSelect={handleSelectAppTraffic}
                dateSelection={dateSelectionAppTraffic}
                datesBetween={datesBetweenAppTraffic}
                dropdrownshow={dropdrownshowAppTraffic}
                setdropdrownshow={(e) => {
                  if (typeof e === "boolean") setdropdrownshowAppTraffic(e);
                }}
                setdateSelection={() => {
                  setdateSelectionAppTraffic({
                    ...dateSelectionAppTraffic,
                    ...datesBetweenAppTraffic,
                  });
                }}
                city={appTrafficGraphCity}
                date={appTrafficGraphDate}
                onChangeCity={setAppTrafficGraphCity}
                top5Commodity={true}
                onChangeDate={appTrafficGraphDateChange}
                TopButtonText={"Top 10 Cities"}
                text={"App Traffic Analyses"}
              />
            </Card>
          </Col>
        </Row>

        <Row style={{ marginBottom: "20px" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card>
              <CommodityGraph data={appTraffic} />
            </Card>
          </Col>
        </Row>

        {/* Commodity trend graph controls */}
        <Row style={{ marginTop: "20px" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card>
              <TopFeature
                showcalender={true}
                PickDate={PickDateCommodity}
                handleSelect={handleSelectCommodity}
                dateSelection={dateSelectionCommodity}
                datesBetween={datesBetweenCommodity}
                dropdrownshow={dropdrownshowCommodity}
                setdropdrownshow={(e) => {
                  if (typeof e === "boolean") setdropdrownshowCommodity(e);
                }}
                setdateSelection={() => {
                  setdateSelectionCommodity({
                    ...dateSelectionCommodity,
                    ...datesBetweenCommodity,
                  });
                }}
                showCity={true}
                city={graphCity}
                onToggleCommodity={onToggleCommodity}
                onChangeCity={setGraphCity}
                top5Commodity={false}
                TopButtonText={!top5Toggle ? "Top 5 Commodities" : "All Commodities"}
                text={"Commodity Analytics"}
              />
            </Card>
          </Col>
        </Row>

        <Row style={{ marginBottom: "20px" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card>
              <CommodityGraph data={data} />
            </Card>
          </Col>
        </Row>
      </div>

      <CardDetail />
    </div>
  );
};
export default Body;
